import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { CDropdownItem } from '@coreui/react-pro';

import { tryParseJSON } from '../../utils';
import { LOCAL_LOGIN_AS_SESSION, LOCAL_ORG_USER, SUBSCRIBER_USER_ROLES, USER_ROLES } from '../../constants';

import { fetchLoginAsSessionDetailRequest, loginAsRequest } from './actions';

let loginAsSessionFlag = false;

const LoginAs = () => {
     const dispatch = useDispatch();
     const navigate = useNavigate();

     const showLoginAs = useSelector((state) => state.general.showLoginAs);
     const [userAdmin, setUserAdmin] = useState();

     const localLoginAsSession = tryParseJSON(localStorage.getItem(LOCAL_LOGIN_AS_SESSION));
     const orgUser = JSON.parse(localStorage.getItem(LOCAL_ORG_USER));

     const fetchLoginAsSession = async () => {
          if (localLoginAsSession && !loginAsSessionFlag) {
               loginAsSessionFlag = true;
               const loginAsSessionRes = await fetchLoginAsSessionDetailRequest(localLoginAsSession.id);
               loginAsSessionFlag = false;

               setUserAdmin(loginAsSessionRes);
               return loginAsSessionRes;
          }
     };

     useEffect(() => {
          fetchLoginAsSession();
     }, []); // eslint-disable-line react-hooks/exhaustive-deps

     const handleSwitchToUser = async () => {
          const currentUserAdmin = { ...userAdmin };

          // Retry once if the admin user information has not been retrieved
          if (!currentUserAdmin) {
               const userAdminLoginAsSessionRes = await fetchLoginAsSession();
               Object.assign(currentUserAdmin, userAdminLoginAsSessionRes);
          }

          if (!currentUserAdmin) {
               toast.error('The login session has ended. Please refresh the page or sign out.');
               return;
          }

          const userValues = {
               id: currentUserAdmin.id,
               firstName: currentUserAdmin.firstName,
               lastName: currentUserAdmin.lastName,
               email: currentUserAdmin.email,
               role: currentUserAdmin.role,
               country: currentUserAdmin.country,
          };

          const nextDispatch = {
               role: USER_ROLES.SUBSCRIBER,
               type: orgUser ? SUBSCRIBER_USER_ROLES.ORGANIZATION : SUBSCRIBER_USER_ROLES.INDIVIDUAL,
               navigate,
          };

          dispatch(loginAsRequest(userValues, nextDispatch));
     };

     if (!showLoginAs && !localLoginAsSession) {
          return null;
     }

     return (
          <CDropdownItem className="sign-out" disabled={!userAdmin} onClick={handleSwitchToUser}>
               Exit to customer support cms
          </CDropdownItem>
     );
};

export default LoginAs;
